import React, { Component } from 'react'
import { Container, Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import { Carousel } from 'react-bootstrap'
import CR1 from 'images/CustomerReview/CR1.png'
import CR2 from 'images/CustomerReview/CR2.png'
import CR3 from 'images/CustomerReview/CR3.png'
export class CustomerReview extends Component {
  render() {
    return (
      <>
        <div className="main-review headding" id="Blog">
          <Container>
            <div className=" textblock">
              

              <Carousel variant="dark" controls={false}    >
                <Carousel.Item>
                  <Row className="customerReview">
                    <Col  md={2} xs={12} >
                      <img className="img-fluid mx-auto img-circle img--size" src={CR1} alt="Review" />
                    </Col>

                    <Col  md={10} xs={12} className="customerP">
                      <p>Sed elit quam, iaculis sed semper sit amet udin vittheae nibi at magna akal semperFusce commodo molestie  elit quam, iaculis sed sempsum Dolort tusima olatiup udin vitae magna semperFusceSed elit quam, iaculis sed semper udin vitae nibh. at magna akal semperFusce.</p>
                      <div className="d-inline-block">
                        <span className="customerspan1" >Mr.John Doe  </span>
                        <span className="customerspan2"> - Designer</span>
                      </div>
                    </Col>
                  </Row>
                  
                </Carousel.Item>
                <Carousel.Item>
                 
                  <Row className="customerReview">
                    <Col  md={2} xs={12}>
                      <img className="img-fluid mx-auto img-circle  img--size" src={CR2} alt="Review" />
                    </Col>

                    <Col  md={10} xs={12} className="customerP">
                      <p>Sed elit quam, iaculis sed semper sit amet udin vittheae nibi at magna akal semperFusce commodo molestie  elit quam, iaculis sed sempsum Dolort tusima olatiup udin vitae magna semperFusceSed elit quam, iaculis sed semper udin vitae nibh. at magna akal semperFusce.</p>
                      <div className="d-inline-block">
                        <span className="customerspan1" >Mr.John Doe  </span>
                        <span className="customerspan2"> - Designer</span>
                      </div>
                    </Col>
                  </Row>
                </Carousel.Item>
                <Carousel.Item>
                 
                  <Row className="customerReview">
                    <Col  md={2} xs={12}>
                      <img className="img-fluid mx-auto img-circle  img--size" src={CR3}  alt="Review"/>
                    </Col>

                    <Col  md={10} xs={12} className="customerP">
                      <p>Sed elit quam, iaculis sed semper sit amet udin vittheae nibi at magna akal semperFusce commodo molestie  elit quam, iaculis sed sempsum Dolort tusima olatiup udin vitae magna semperFusceSed elit quam, iaculis sed semper udin vitae nibh. at magna akal semperFusce.</p>
                      <div className="d-inline-block">
                        <span className="customerspan1" >Mr.John Doe  </span>
                        <span className="customerspan2"> - Designer</span>
                      </div>
                    </Col>
                  </Row>
                </Carousel.Item>
              </Carousel>
            </div>
          </Container>
        </div>
      </>
    )
  }
}
export default CustomerReview

